/**
 * Paint critical-path row tint on smart-rendered rows.
 * `grid_row_class` applies the class on later scrolls; visible rows need an immediate pass.
 */
export type CriticalHighlightPaint = {
  ids: Set<string>;
  /** True when any critical task is overdue — strip uses red instead of blue. */
  overdue: boolean;
};

export function syncVisibleCriticalHighlightClasses(
  root: ParentNode,
  paint: CriticalHighlightPaint,
): void {
  root
    .querySelectorAll('.gantt_row[data-task-id], .gantt_task_row[data-task-id]')
    .forEach((node) => {
      const el = node as HTMLElement;
      const id = el.getAttribute('data-task-id');
      const on = id != null && paint.ids.has(id);
      el.classList.toggle('gantt-row-critical-highlight', on);
      el.classList.toggle('gantt-row-critical-highlight--overdue', on && paint.overdue);
    });
}
